import React, { Component } from 'react';
import PT from 'prop-types';
import { loadAllQuestionnaires, SaleQuestionnaireIDModelShape, TicketInfoShape } from './questionnairemanagementhelper';
import { SaleQuestionnaireAutoForm } from './salequestionnaireautoform';
import { ResponsiveEmptyBox } from './modal';
import { groupBy, head, map, find, reduce, reject } from 'lodash';


// Ce controle sert à faire en sorte qu'un utilisateur rempli tous les
// questionnaires necessaires à sa vente, selon son panier d'achat.
// De là le nom fillout manager. Il gère le remplissage de formulaire au
// long du processus de vente.
export class SaleQuestionnaireFilloutManager extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            eventForms: [],
            questionnaireStates: null,
            showSaleQuestionnaire: false,
            key: 0
        };

        this.handlePopupClose = this.handlePopupClose.bind(this);
        this.handleAfterConfirm = this.handleAfterConfirm.bind(this);
        this.raiseContentChanged = this.raiseContentChanged.bind(this);
    }
    
    async componentDidMount() {
        this.setState({ processing: true });
        
        if (this.props.saleQuestionnaires !== null && this.props.saleQuestionnaires.SaleQuestionnaireIDs !== null && this.props.saleQuestionnaires.SaleQuestionnaireIDs.length > 0) {

            const saleQuestionnairesSelected = this.props.saleQuestionnaires.SaleQuestionnaireIDs;
            
            //On groupe les questionnaires par ID Uniq car ca va servir a les afficher tous en meme temps
            const questionnairesGrouped = groupBy(saleQuestionnairesSelected, (quest) => this.getGroupedQuestUniqID(quest));
            
            // on creer un object de state qui nous dit si le formulaire est bien rempli
            const questionnaireStates = map(questionnairesGrouped, (quest, key) => ({ key: key, eventID: head(quest).EventID, ownerPOSID: head(quest).OwnerPOSID, questionnaires: quest, isOk: false }));

            try {
                setTimeout(async function(){
                    const forms = await loadAllQuestionnaires(questionnaireStates, this.props.sellerUserId);
                    this.setState({forms: forms, showSaleQuestionnaire:true, questionnaireStates: questionnaireStates });
                }.bind(this), 500);
            }
            //TODO: Do something with the error
            //eslint-disable-next-line sonarjs/no-ignored-exceptions
            catch(err)
            {
                console.log("Check the definition of the sale questionaire form !");
            }
            finally
            {
                this.setState({ processing:false });
            }
        }
        
        this.raiseContentChanged();
    }

    raiseContentChanged() {
        // Set timeout because even though React rendered the tags, they are not yet drawn on the screen.
        setTimeout(function(){
            if(this.props.onContentChange !== undefined) this.props.onContentChange();
        }.bind(this), 500);
    }

    getGroupedQuestUniqID(questionnaire) {
        return `${questionnaire.PackageID}_${questionnaire.EventID}_${questionnaire.EventDateID}_${questionnaire.OwnerPOSID}`;
    }

    handlePopupClose() {
        this.setState({ showSaleQuestionnaire: false });
        if(this.props.onCancel != null) this.props.onCancel();
    }
    
    getSaleQuestionnaireKit(questionnaireState) {
        let questionnaire = { EventForms: { orderForms: [], ticketForms: [] }, POSForms: { cartForms: [] } };

        const firstQuest = head(questionnaireState.questionnaires);
        
        const posForms = find(this.state.forms, { 'OwnerPOSID': firstQuest.OwnerPOSID });
        if(posForms)
            questionnaire.POSForms = JSON.parse(posForms.SaleQuestionnaires);
        
        const eventForms = find(this.state.forms, { 'EventID': firstQuest.EventID });
        if(eventForms)
            questionnaire.EventForms = JSON.parse(eventForms.SaleQuestionnaires);

        questionnaire.PackageID = firstQuest.PackageID;
        questionnaire.EventID = firstQuest.EventID;
        questionnaire.EventDateID = firstQuest.EventDateID;
        questionnaire.OrderID = firstQuest.OrderID;
        questionnaire.CartID = firstQuest.CartID;
        questionnaire.OwnerPOSID = firstQuest.OwnerPOSID;
        
        const ticketIDs = map(reject(questionnaireState.questionnaires, { TicketID: 0 }), "TicketID");
        const ticketInfoByID = reduce(this.props.saleQuestionnaires.TicketInfos, function(acc, val) {  acc[val.id] = val; return acc; }, {});
        questionnaire.TicketInfos = map(ticketIDs, (id) => { return ticketInfoByID[id]; });
        
        return questionnaire;
    }

    getFirstUnfillQuestionnaireState() {
        const questState = find(this.state.questionnaireStates, { 'isOk': false });
        
        return questState;
    }

    changeQuestionnaireState(){
        const currentQuestionnaireState = this.getFirstUnfillQuestionnaireState();
        currentQuestionnaireState.isOk = true;
        this.setState({ questionnaireStates: this.state.questionnaireStates, showSaleQuestionnaire: true, key: (this.state.key + 1) });
    }

    handleAfterConfirm() {
        this.changeQuestionnaireState();

        const currentQuestionnaire = this.getFirstUnfillQuestionnaireState();

        if(currentQuestionnaire === undefined && this.props.onSave !== undefined) {
            this.props.onSave();
        }
    }

    render() {
        let saleQuestionnairePanel = null;
        if (this.state.questionnaireStates != null) {
            const currentQuestionnaire = this.getFirstUnfillQuestionnaireState();

            if(currentQuestionnaire != null && this.state.showSaleQuestionnaire) {
                if(this.props.showInPopup) {
                    saleQuestionnairePanel = (
                        <ResponsiveEmptyBox onClose={this.handlePopupClose}  zIndex={10000} popupWidth={this.props.popupWidth}>
                            <div className="container-fluid text-left">
                                <SaleQuestionnaireAutoForm 
                                    key={this.state.key}
                                    saleQuestionnaireKit={this.getSaleQuestionnaireKit(currentQuestionnaire)}
                                    afterConfirm={this.handleAfterConfirm}
                                    onCancel={this.handlePopupClose}
                                    onContentChange={this.raiseContentChanged}
                                    isInAdmin={this.props.isInAdmin}
                                    viewProvider={this.props.viewProvider}>
                                </SaleQuestionnaireAutoForm>
                            </div>
                        </ResponsiveEmptyBox>
                    );
                }
                else {
                    saleQuestionnairePanel = (
                        <div className="container-fluid text-left">
                            <SaleQuestionnaireAutoForm
                                viewProvider={this.props.viewProvider}
                                key={this.state.key}
                                saleQuestionnaireKit={this.getSaleQuestionnaireKit(currentQuestionnaire)}
                                isInAdmin={this.props.isInAdmin}
                                afterConfirm={this.handleAfterConfirm}
                                onCancel={this.handlePopupClose}
                                onContentChange={this.raiseContentChanged}>        
                            </SaleQuestionnaireAutoForm>
                        </div>
                    );
                }
            }
        }
        
        return <div>{saleQuestionnairePanel}</div>;
    }
}

SaleQuestionnaireFilloutManager.propTypes = {
    saleQuestionnaires: PT.shape({
        SaleQuestionnaireIDs: PT.arrayOf(SaleQuestionnaireIDModelShape), // REST.Models.SaleQuestionnaireID
        TicketInfos: PT.arrayOf(TicketInfoShape)
    }),
    showInPopup: PT.bool,
    sellerUserId: PT.number, // Not really used correctly yet but it should be
    onCancel: PT.func,
    onSave: PT.func,
    onContentChange: PT.func,
    modalViewsProvider: PT.object,
    isInAdmin: PT.bool,
    viewProvider: PT.object,
    popupWidth: PT.string
};


SaleQuestionnaireFilloutManager.defaultProps = {
    showInPopup: true,
    popupWidth: '78%'
};
